import { SortingState } from '@tanstack/react-table';

export type TimeFormat = 'formatted' | 'minutes' | 'clock';
export type FormatTimeFn = (minutes: number, format: TimeFormat) => string;

export type RatioColumnLabels = {
  title: string;
  percentage: string;
  totalTime: string;
  count: string;
  averageTimePerCount: string;
  averageTimePerDay: string;
};

export type TransitionColumnLabels = {
  date: string;
  time: string;
};

// 表をコピー用の関数
export const copyTableToClipboard = (
  table: any,
  timeFormat: TimeFormat,
  formatTime: FormatTimeFn,
  setCopied: (copied: boolean) => void,
): void => {
  const headers = table
    .getFlatHeaders()
    .map((header: any) => header.column.columnDef.header)
    .join('\t');
  const rows = table.getRowModel().rows.map((row: any) =>
    row
      .getVisibleCells()
      .map((cell: any) => {
        const value = cell.getContext().getValue();
        return typeof value === 'number' &&
          ['totalTime', 'averageTimePerCount', 'averageTimePerDay', 'time'].includes(cell.column.id)
          ? formatTime(value, timeFormat)
          : value;
      })
      .join('\t'),
  );
  const csv = [headers, ...rows].join('\n');
  navigator.clipboard.writeText(csv).then(() => {
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  });
};

// 比率テーブルのカラム定義
export const getRatioColumns = (
  timeFormat: TimeFormat,
  formatTime: FormatTimeFn,
  labels: RatioColumnLabels,
) => [
  { accessorKey: 'title', header: labels.title },
  { accessorKey: 'percentage', header: labels.percentage },
  {
    accessorKey: 'totalTime',
    header: labels.totalTime,
    cell: (info: any) => formatTime(info.getValue() as number, timeFormat),
  },
  { accessorKey: 'count', header: labels.count },
  {
    accessorKey: 'averageTimePerCount',
    header: labels.averageTimePerCount,
    cell: (info: any) => formatTime(info.getValue() as number, timeFormat),
  },
  {
    accessorKey: 'averageTimePerDay',
    header: labels.averageTimePerDay,
    cell: (info: any) => formatTime(info.getValue() as number, timeFormat),
  },
];

// 遷移テーブルのカラム定義
export const getTransitionColumns = (
  timeFormat: TimeFormat,
  formatTime: FormatTimeFn,
  labels: TransitionColumnLabels,
) => [
  { accessorKey: 'date', header: labels.date },
  {
    accessorKey: 'time',
    header: labels.time,
    cell: (info: any) => formatTime(info.getValue() as number, timeFormat),
  },
];

// デフォルトのソート状態
export const getDefaultSorting = (tableType: 'ratio' | 'transition'): SortingState => {
  return [{ id: tableType === 'ratio' ? 'percentage' : 'date', desc: false }];
};
